import { z } from "zod";
import { baseEntity, slugInput, tagsSchema } from "./common.js";

export const ritual = baseEntity.extend({
  /** Week number, e.g. 27. */
  week: z.number().int().positive(),
  title: z.string().min(1).max(240),
  /** Human display date, e.g. "Jul 3, 2026". */
  displayDate: z.string().min(1).max(60),
  /** Markdown body of the weekly note. */
  content: z.string().min(1),
});
export type Ritual = z.infer<typeof ritual>;

export const ritualInput = z.object({
  week: z.number().int().positive(),
  title: z.string().min(1).max(240),
  displayDate: z.string().min(1).max(60),
  content: z.string().min(1),
  slug: slugInput,
  tags: tagsSchema.default([]),
  published: z.boolean().default(true),
  sortOrder: z.number().int().default(0),
});
export type RitualInput = z.infer<typeof ritualInput>;

export const ritualUpdate = ritualInput.partial();
export type RitualUpdate = z.infer<typeof ritualUpdate>;
